import React, { useState } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import NavbarAdmin from '../components/NavbarAdmin';

const AddComite = () => {
  const [comite, setComite] = useState({
    lien: ''
  });

 

  // Handle changes in form inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setComite({ ...comite, [name]: value });
  };

  // Function to convert Google Drive view link to preview link
  const convertToPreviewLink = (link) => {
    if (link.includes('drive.google.com')) {
      return link.replace('/view', '/preview');
    }
    return link; // Return the link unchanged if it's not a Google Drive link
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const previewLink = convertToPreviewLink(comite.lien); // Convert the link before saving
    try {
      await addDoc(collection(db, 'comite'), {
        ...comite,
        lien: previewLink, // Save the converted link
        timestamp: Timestamp.now()
      });
      console.log("Document successfully written!");
      // Clear the form after successful submission
      setComite({
        lien: ''
      });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0 auto',
    maxWidth: '600px',
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  return (
    <div>
      <NavbarAdmin />
      <div style={containerStyle}>
        <h2 style={headingStyle}>Ajouter Comité</h2>
        <form onSubmit={handleSubmit} style={formStyle}>
         
          <label>
            Lien Drive :
            <input
              type="text"
              name="lien"
              value={comite.lien}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <button type="submit" style={buttonStyle}>Ajouter</button>
        </form>
      </div>
    </div>
  );
};

export default AddComite;
